<template>
  <div style="position: relative;">
    <img width="100%" src="@/assets/about.jpg" alt="banner" class="imgs"/>
    <div class="banner-text" 
        style=" margin-top: -50px; width: 90%; text-align: center;"
        :style="{
          fontSize: china ? '32px' : '44px'
        }"
    >
      <p>{{lang.aboutFintech}}</p>
      <p style="margin-top: 10px;">{{lang.aboutFintech1}}</p>
    </div>
    <div 
      class="font-panel"
      :style="{
        bottom: china ? '-50px' : '-94px'
      }"
    >
      <span>
        <img src="@/assets/icon/ab-L.png" style="width: 15px; height: 9px; position: absolute; top: 14px; left: 16px;">
        <img src="@/assets/icon/ab-R.png" style="width: 15px; heihgt: 9px; position: absolute; bottom: 14px; right: 16px;">
        <p style="text-align: left;">
          {{lang.aboutUsContentShort}}
        </p>
      </span>
    </div>
  </div>
</template>
<script>
import mapStore from '@/mixins/mapStore'
export default {
  name: 'aboutBanner',
  mixins: [
    mapStore('', {
      getters: ['lang', 'china']
    })
  ]
}
</script>
<style lang="less" scoped>
  .imgs{
    display: block;
  }
  .font-panel {
    position: absolute;
    width: 100%;
    text-align: center;
    span {
      display: block;
      margin: 0 auto;
      position: relative;
      background: white;
      margin: 0 15px;
      text-align: center;
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
      padding: 30px 0;
      p {
        display: inline-block;
        position: relative;
        font-size: 15px;
        font-weight: 300;
        line-height: 22px;
        padding: 0 30px;
        box-sizing: border-box;
        text-align: center;
      }
    }
  }
</style>